var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Anda tidak memiliki hak akses ke halaman ini !!!")]),_c('p',[_c('v-btn',{attrs:{"to":"/"}},[_vm._v("Kembali ke Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }